import { render, staticRenderFns } from "./DetailPosCustomer.vue?vue&type=template&id=099c6ff2&scoped=true"
import script from "./DetailPosCustomer.vue?vue&type=script&lang=js"
export * from "./DetailPosCustomer.vue?vue&type=script&lang=js"
import style0 from "./DetailPosCustomer.vue?vue&type=style&index=0&id=099c6ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c6ff2",
  null
  
)

export default component.exports